import { apiFetch, getStoredToken, setStoredToken } from "./client.ts";

export interface AuthUser {
  id: string;
  name: string;
  email: string;
  image: string | null;
}

interface AuthResponse {
  user: AuthUser;
  token: string;
}

interface SessionResponse {
  session: { id: string; userId: string; token: string; expiresAt: string };
  user: AuthUser;
}

export async function signUp(
  name: string,
  email: string,
  password: string,
): Promise<AuthUser> {
  const res = await apiFetch<AuthResponse>("/api/auth/sign-up/email", {
    method: "POST",
    body: { name, email, password },
  });
  setStoredToken(res.token);
  return res.user;
}

export async function signIn(
  email: string,
  password: string,
): Promise<AuthUser> {
  const res = await apiFetch<AuthResponse>("/api/auth/sign-in/email", {
    method: "POST",
    body: { email, password },
  });
  setStoredToken(res.token);
  return res.user;
}

export async function signOut(): Promise<void> {
  try {
    await apiFetch("/api/auth/sign-out", { method: "POST" });
  } finally {
    setStoredToken(null);
  }
}

export async function getSession(): Promise<AuthUser | null> {
  if (!getStoredToken()) return null;
  try {
    const res = await apiFetch<SessionResponse>("/api/auth/get-session");
    return res?.user ?? null;
  } catch {
    setStoredToken(null);
    return null;
  }
}
